module.exports = __webpack_public_path__ + "yeni fransa mutfak 9.jpg?45cf0f4dd98dcf304267465596ca65ee";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fransa mutfak 9.jpg
// module id = 370
// module chunks = 0